/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const confirmedBookingDataSchema = z.object({
	scheduledAt: z.string(),
	durationMinutes: z.number(),
})

export type ConfirmedBookingDataSchema = z.infer<typeof confirmedBookingDataSchema>
